import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAuthSession } from 'aws-amplify/auth';

import { loginWithGoogleSuccessAction, signInWithCognitoSuccessAction, loginWithGoogleErrorAction } from './redux/actions';
import { getUserRequestAction } from '../../components/users/get-user/redux/action';
import { setAuthenticatedClient } from '../../client/graphql';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import AWS from 'aws-sdk';
import { subscribeDeviceRequestAction } from '../../components/devices/subscribe-device/redux/actions';

const AuthLoader: React.FC = () => {
  const dispatch = useDispatch();
  const isSubscribed = useSelector((state: RootState) => state.subscribeDeviceReducer.isSubscribed);
  console.log('isSubscribed', isSubscribed);
  useEffect(() => {
    async function checkSession() {
        try {
          AWS.config.update({ region: 'us-west-2' });
          const session = await fetchAuthSession({ forceRefresh: true });
          console.log('Session from AuthLoader: ', session);
          
          if (session && session.tokens && session.userSub) {
            dispatch(loginWithGoogleSuccessAction(session));
            await setAuthenticatedClient();
            dispatch(subscribeDeviceRequestAction());
            dispatch(getUserRequestAction(session));
          } else {
            console.log('No valid session found');
          }
        } catch (sessionError) {
          console.error('Error fetching auth session:', sessionError);
          dispatch(loginWithGoogleErrorAction(sessionError));
        }
    }
    checkSession();
  }, [dispatch]);

  return null;
};

export default AuthLoader; 